export type DocumentTemplateSectionDependenciesWarnedPayload = {
	message: string;
};

export type DocumentTemplateSectionDependenciesWarnedAction = {
	type: 'DOCUMENT_TEMPLATE_SECTION_DEPENDENCIES_WARNED';
	payload: DocumentTemplateSectionDependenciesWarnedPayload;
};

export default (
	payload: DocumentTemplateSectionDependenciesWarnedPayload,
): DocumentTemplateSectionDependenciesWarnedAction => ({
	type: 'DOCUMENT_TEMPLATE_SECTION_DEPENDENCIES_WARNED',
	payload,
});
